
import formAPIOrdersFollowUp from "./followup";


var formattedOutput = null;

const formAPIModelOrdersFollowUps = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data?.map(item => formAPIOrdersFollowUp(item));


  return formattedOutput
};

export default formAPIModelOrdersFollowUps